export default "__VITE_ASSET__BtKpWTgM__"